import { AccountBean, ItemResponseAccountBeanObject } from 'src/api/api'
import accountApi from 'src/component/app/account/AccountApi'
import 'src/component/app/sidebar/style.css'
import { User } from 'src/context/UserContext'
import { StorageKey } from './Storage'
import RoleEnum = AccountBean.RoleEnum
import dayjs from 'dayjs'

export const enumView = (key: any) => {
    return key.replace(/([a-z])([A-Z])/g, '$1 $2')
}

export const capitalizedView = (key: any) => {
    return key.charAt(0) + key.slice(1).toLowerCase()
}

export function isAuthenticated() {
    if (localStorage.getItem(StorageKey.Authenticated) === 'true') {
        const expirationString = localStorage.getItem(StorageKey.TokenExpiration)
        if (expirationString) {
            const expiration: number = +expirationString
            if (expiration > Date.now()) {
                return true
            }
        }
    }
    return false
}

export function isAdmin(user) {
    return user?.role == RoleEnum.Admin
}

export function isAgencyAdmin(user) {
    return user?.role == RoleEnum.AgencyAdmin
}

export function isAgencyManager(user) {
    return user?.role == RoleEnum.AgencyManager
}

export function setLoggedUserProps(setUser: (u: User) => void) {
    accountApi.viewUser().then((item: ItemResponseAccountBeanObject) => {
        if (item.data) {
            setUser({
                id: item.data.id ?? -1,
                email: item.data.email ?? '',
                role: item.data.role ?? undefined,
            })
        }
    })
}

export function clone(obj) {
    var copy

    // Handle the 3 simple types, and null or undefined
    if (null == obj || 'object' != typeof obj) {
        return obj
    }

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date()
        copy.setTime(obj.getTime())
        return copy
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = []
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = clone(obj[i])
        }
        return copy
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {}
        for (const attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                copy[attr] = clone(obj[attr])
            }
        }
        return copy
    }

    throw new Error('Unable to copy obj! Its type isn\'t supported.')
}

interface IabCategory {
    id: number,
    parentId: number,
    name: string,
    code: string
}

interface TreeSelectData {
    title: string,
    value: number,
    key: number,
    children?: TreeSelectData[]
}

export function getIabCategoriesAsTree(list: IabCategory[]) {
    const root: TreeSelectData[] = []
    list.filter(v => v.parentId == null)
        .forEach(v => root.push({
            title: v.name,
            key: v.id,
            value: v.id,
            children: []
        }))
    list.filter(v => v.parentId != null)
        .forEach(v => {
            const group = root.find(item => item.value === v.parentId)
            if (group != undefined && group.children != undefined) {
                group.children.push({
                    title: v.name,
                    key: v.id,
                    value: v.id,
                })
            }
        })
    return root
}

export const LIST_PAGE_SIZE = 10

export function uuidV4() {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c: any) =>
        // tslint:disable-next-line:no-bitwise
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
}

export const lowerize = object => Object.keys(object).reduce((prev, current) => {
    const value = object[current]
    prev[current.toLowerCase()] = value
    prev['key'] = 'totals'
    return prev
}, {})

export function downloadCSVData(fileName: string, csvData: Blob) {
    const a = window.document.createElement('a')
    a.href = URL.createObjectURL(csvData)
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}

export const formatCompact = (value: number, toUnits: ((formatted) => string) | undefined = undefined): string => {

    let formatted: string
    const digits = toUnits ? 2 : 0

    if (Math.abs(value) >= 1_000_000_000) {
        formatted = (value / 1_000_000_000).toFixed(digits) + 'B'
    } else if (Math.abs(value) >= 1_000_000) {
        formatted = (value / 1_000_000).toFixed(digits) + 'M'
    } else if (Math.abs(value) >= 1_000) {
        formatted = (value / 1_000).toFixed(digits) + 'K'
    } else {
        formatted = value.toFixed(digits)
    }

    return toUnits ? toUnits(formatted) : formatted
}

export const formatLocale = (value: number, toUnits: ((formatted) => string) | undefined = undefined): string => {

    const digits = toUnits ? 2 : 0

    const formatted = value.toLocaleString('en-US', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    })

    return toUnits ? toUnits(formatted) : formatted
}

export const daysToEnd = (now, endDate) => {
    const end = dayjs(endDate, 'YYYY-MM-DD HH:mm')
    return end.isAfter(now) ? end.diff(now, 'day') : 0
}


// WEBPACK FOOTER //
// ./src/util/Util.tsx